import { render, staticRenderFns } from "./BulkProspectViewingForm.vue?vue&type=template&id=2328d056&"
import script from "./BulkProspectViewingForm.vue?vue&type=script&lang=js&"
export * from "./BulkProspectViewingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports